import { render, staticRenderFns } from "./ProductVideoStructuredData.vue?vue&type=template&id=18f067a7"
import script from "./ProductVideoStructuredData.vue?vue&type=script&lang=js"
export * from "./ProductVideoStructuredData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports